function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { MultiDisposer } from "../util/Disposer";
import { Label } from "../render/Label";
import { PointedRectangle } from "../render/PointedRectangle";
import { Container } from "./Container";
import { Percent } from "../util/Percent";
import { Color } from "../util/Color";
import * as $math from "../util/Math";
import * as $array from "../util/Array";
import * as $utils from "../util/Utils";
/**
 * Creates a tooltip.
 *
 * @see {@link https://www.amcharts.com/docs/v5/concepts/common-elements/tooltips/} for more info
 * @important
 */
export var Tooltip = /*#__PURE__*/function (_Container) {
  _inherits(Tooltip, _Container);
  var _super = _createSuper(Tooltip);
  function Tooltip(root, settings, isReal) {
    var _this;
    var templates = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    _classCallCheck(this, Tooltip);
    _this = _super.call(this, root, settings, isReal, templates);
    Object.defineProperty(_assertThisInitialized(_this), "_fx", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_fy", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_label", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_fillDp", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_strokeDp", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_labelDp", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_w", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_h", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_keepHoverDp", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    return _this;
  }
  _createClass(Tooltip, [{
    key: "_afterNew",
    value: function _afterNew() {
      var _this2 = this;
      this._settings.themeTags = $utils.mergeTags(this._settings.themeTags, ["tooltip"]);
      _get(_getPrototypeOf(Tooltip.prototype), "_afterNew", this).call(this);
      this.set("background", PointedRectangle.new(this._root, {
        themeTags: ["tooltip", "background"]
      }));
      this._label = this.children.push(Label.new(this._root, {}));
      this._disposers.push(this._label.events.on("boundschanged", function () {
        _this2._updateBackground();
      }));
      this._disposers.push(this.on("bounds", function () {
        _this2._updateBackground();
      }));
      this._updateTextColor();
      this._root.tooltipContainer.children.push(this);
      this.hide(0);
      this._root._tooltips.push(this);
    }
    /**
     * A [[Label]] element for the tooltip.
     *
     * @readonly
     * @return Label
     */
  }, {
    key: "label",
    get: function get() {
      return this._label;
    }
    /**
     * Permanently disposes the tooltip.
     */
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Tooltip.prototype), "dispose", this).call(this);
      $array.remove(this._root._tooltips, this);
    }
  }, {
    key: "_updateChildren",
    value: function _updateChildren() {
      _get(_getPrototypeOf(Tooltip.prototype), "_updateChildren", this).call(this);
      var labelText = this.get("labelText");
      if (labelText != null) {
        this.label.set("text", this.get("labelText"));
      }
      var labelHTML = this.get("labelHTML");
      if (labelHTML != null) {
        this.label.set("html", this.get("labelHTML"));
      }
    }
  }, {
    key: "_changed",
    value: function _changed() {
      var _this3 = this;
      _get(_getPrototypeOf(Tooltip.prototype), "_changed", this).call(this);
      if (this.isDirty("pointTo")) {
        // can't compare to previous, as sometimes pointTo is set twice (when pointer moves, so the position won't be udpated)
        this._updateBackground();
      }
      if (this.isDirty("tooltipTarget")) {
        this.updateBackgroundColor();
      }
      if (this.isDirty("keepTargetHover")) {
        var keephover = this.get("keepTargetHover");
        if (keephover) {
          var bg = this.get("background");
          this._keepHoverDp = new MultiDisposer([bg.events.on("pointerover", function (_ev) {
            var target = _this3.get("tooltipTarget");
            if (target) {
              if (target.parent && target.parent.getPrivate("tooltipTarget") == target) {
                target = target.parent;
              }
              target.hover();
            }
          }), bg.events.on("pointerout", function (_ev) {
            var target = _this3.get("tooltipTarget");
            if (target) {
              if (target.parent && target.parent.getPrivate("tooltipTarget") == target) {
                target = target.parent;
              }
              target.unhover();
            }
          })]);
        } else {
          if (this._keepHoverDp) {
            this._keepHoverDp.dispose();
            this._keepHoverDp = undefined;
          }
        }
      }
    }
  }, {
    key: "_onShow",
    value: function _onShow() {
      _get(_getPrototypeOf(Tooltip.prototype), "_onShow", this).call(this);
      this.updateBackgroundColor();
    }
  }, {
    key: "updateBackgroundColor",
    value: function updateBackgroundColor() {
      var _this4 = this;
      var tooltipTarget = this.get("tooltipTarget");
      var background = this.get("background");
      var fill;
      var stroke;
      if (tooltipTarget && background) {
        fill = tooltipTarget.get("fill");
        stroke = tooltipTarget.get("stroke");
        if (fill == null) {
          fill = stroke;
        }
        if (this.get("getFillFromSprite")) {
          if (this._fillDp) {
            this._fillDp.dispose();
          }
          if (fill != null) {
            background.set("fill", fill);
          }
          this._fillDp = tooltipTarget.on("fill", function (fill) {
            if (fill != null) {
              background.set("fill", fill);
              _this4._updateTextColor(fill);
            }
          });
          this._disposers.push(this._fillDp);
        }
        if (this.get("getStrokeFromSprite")) {
          if (this._strokeDp) {
            this._strokeDp.dispose();
          }
          if (fill != null) {
            background.set("stroke", fill);
          }
          this._strokeDp = tooltipTarget.on("fill", function (fill) {
            if (fill != null) {
              background.set("stroke", fill);
            }
          });
          this._disposers.push(this._strokeDp);
        }
        if (this.get("getLabelFillFromSprite")) {
          if (this._labelDp) {
            this._labelDp.dispose();
          }
          if (fill != null) {
            this.label.set("fill", fill);
          }
          this._labelDp = tooltipTarget.on("fill", function (fill) {
            if (fill != null) {
              _this4.label.set("fill", fill);
            }
          });
          this._disposers.push(this._labelDp);
        }
      }
      this._updateTextColor(fill);
    }
  }, {
    key: "_updateTextColor",
    value: function _updateTextColor(fill) {
      if (this.get("autoTextColor")) {
        if (fill == null) {
          fill = this.get("background").get("fill");
        }
        if (fill == null) {
          fill = this._root.interfaceColors.get("background");
        }
        if (fill instanceof Color) {
          this.label.set("fill", Color.alternative(fill, this._root.interfaceColors.get("alternativeText"), this._root.interfaceColors.get("text")));
        }
      }
    }
  }, {
    key: "_setDataItem",
    value: function _setDataItem(dataItem) {
      _get(_getPrototypeOf(Tooltip.prototype), "_setDataItem", this).call(this, dataItem);
      this.label._setDataItem(dataItem);
    }
  }, {
    key: "_updateBackground",
    value: function _updateBackground() {
      _get(_getPrototypeOf(Tooltip.prototype), "updateBackground", this).call(this);
      var parent = this._root.container;
      if (parent) {
        var cw = 0.5;
        var ch = 0.5;
        var centerX = this.get("centerX");
        if (centerX instanceof Percent) {
          cw = centerX.value;
        }
        var centerY = this.get("centerY");
        if (centerY instanceof Percent) {
          ch = centerY.value;
        }
        var parentW = parent.width();
        var parentH = parent.height();
        var tooltipContainer = this.parent;
        var xx = 0;
        var yy = 0;
        if (tooltipContainer) {
          xx = tooltipContainer.x();
          yy = tooltipContainer.y();
          var layerMargin = tooltipContainer.get("layerMargin");
          if (layerMargin) {
            xx += layerMargin.left || 0;
            yy += layerMargin.top || 0;
            parentW += (layerMargin.left || 0) + (layerMargin.right || 0);
            parentH += (layerMargin.top || 0) + (layerMargin.bottom || 0);
          }
        }
        var bounds = this.get("bounds", {
          left: -xx,
          top: -yy,
          right: parentW - xx,
          bottom: parentH - yy
        });
        this._updateBounds();
        var w = this.width();
        var h = this.height();
        // use old w and h,as when tooltip is hidden, these are 0 and unneeded animation happens
        if (w === 0) {
          w = this._w;
        }
        if (h === 0) {
          h = this._h;
        }
        var pointTo = this.get("pointTo", {
          x: parentW / 2,
          y: parentH / 2
        });
        var x = pointTo.x;
        var y = pointTo.y;
        var pointerOrientation = this.get("pointerOrientation");
        var background = this.get("background");
        var pointerLength = 0;
        var bgStrokeSizeY = 0;
        var bgStrokeSizeX = 0;
        if (background instanceof PointedRectangle) {
          pointerLength = background.get("pointerLength", 0);
          bgStrokeSizeY = background.get("strokeWidth", 0) / 2;
          bgStrokeSizeX = bgStrokeSizeY;
        }
        var pointerX = 0;
        var pointerY = 0;
        var boundsW = bounds.right - bounds.left;
        var boundsH = bounds.bottom - bounds.top;
        // horizontal
        if (pointerOrientation == "horizontal" || pointerOrientation == "left" || pointerOrientation == "right") {
          bgStrokeSizeY = 0;
          if (pointerOrientation == "horizontal") {
            if (x > bounds.left + boundsW / 2) {
              x -= w * (1 - cw) + pointerLength;
              bgStrokeSizeX *= -1;
            } else {
              x += w * cw + pointerLength;
            }
          } else if (pointerOrientation == "left") {
            x += w * (1 - cw) + pointerLength;
          } else {
            x -= w * cw + pointerLength;
            bgStrokeSizeX *= -1;
          }
        }
        // vertical pointer
        else {
          bgStrokeSizeX = 0;
          if (pointerOrientation == "vertical") {
            if (y > bounds.top + h / 2 + pointerLength) {
              y -= h * (1 - ch) + pointerLength;
            } else {
              y += h * ch + pointerLength;
              bgStrokeSizeY *= -1;
            }
          } else if (pointerOrientation == "down") {
            y -= h * (1 - ch) + pointerLength;
          } else {
            y += h * ch + pointerLength;
            bgStrokeSizeY *= -1;
          }
        }
        x = $math.fitToRange(x, bounds.left + w * cw, bounds.left + boundsW - w * (1 - cw)) + bgStrokeSizeX;
        y = $math.fitToRange(y, bounds.top + h * ch, bounds.top + boundsH - h * (1 - ch)) - bgStrokeSizeY;
        pointerX = pointTo.x - x + w * cw + bgStrokeSizeX;
        pointerY = pointTo.y - y + h * ch - bgStrokeSizeY;
        this._fx = x;
        this._fy = y;
        var animationDuration = this.get("animationDuration", 0);
        if (animationDuration > 0 && this.get("visible") && this.get("opacity") > 0.1) {
          var animationEasing = this.get("animationEasing");
          this.animate({
            key: "x",
            to: x,
            duration: animationDuration,
            easing: animationEasing
          });
          this.animate({
            key: "y",
            to: y,
            duration: animationDuration,
            easing: animationEasing
          });
        } else {
          this.set("x", x);
          this.set("y", y);
        }
        if (background instanceof PointedRectangle) {
          background.set("pointerX", pointerX);
          background.set("pointerY", pointerY);
        }
        if (w > 0) {
          this._w = w;
        }
        if (h > 0) {
          this._h = h;
        }
      }
    }
  }]);
  return Tooltip;
}(Container);
Object.defineProperty(Tooltip, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Tooltip"
});
Object.defineProperty(Tooltip, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Container.classNames.concat([Tooltip.className])
});